export const CUSTOMER_EXPERIENCE_V2 = {
  label: 'Customer Experience App 2',
  value: 'customer-experience-v2',
  navigationLimit: 5,
  tabs: ['modules', 'branding', 'integrations', 'profile-viewer', 'userContext', 'share'],
  authOptions: [{ label: 'None', value: 'none' }],
}
